import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import PageWrap from '../components/PageWrap';
import useDocumentMeta from '../hooks/useDocumentMeta';
import routeMetaFor from '../utils/routeMeta';
import { APPS_PAGE, STUDIO, products } from '../data/siteContent';

export default function Apps() {
  useDocumentMeta(routeMetaFor('/apps'));
  return (
    <PageWrap testId="apps-page">
      <Navbar />
      <section className="page-hero">
        <div className="blob blob-1"></div>
        <div className="blob blob-2"></div>
        <div className="wrap" style={{ position: 'relative', zIndex: 1 }}>
          <div className="eyebrow reveal">{APPS_PAGE.eyebrow}</div>
          <h1 className="reveal d1">{APPS_PAGE.title}</h1>
          <p className="lead reveal d2">{STUDIO.supportingStatement}</p>
        </div>
      </section>

      {/* Text-led catalogue: live products first, then anything in development.
          Only products with an approved store URL get an external button. */}
      <section className="section">
        <div className="wrap">
          {products.map((product, i) => (
            <div key={product.id} data-testid={`product-${product.id}`} style={{ marginBottom: i === products.length - 1 ? 0 : '48px' }}>
              {i > 0 && <div className="rule" style={{ marginBottom: '48px' }}></div>}
              <div className="icon-box reveal"><i className={`fas ${product.icon}`}></i></div>
              <div className={`tag ${product.productPath ? 'tag-live' : 'tag-soon'} reveal`} style={{ marginBottom: '14px' }}>
                {product.productPath && <i className="fas fa-circle" style={{ fontSize: '6px' }}></i>} {product.status}
              </div>
              <h2 className="reveal d1">{product.name}</h2>
              <p className="reveal d2" style={{ marginTop: '12px', marginBottom: '24px', maxWidth: '760px' }}>
                {product.positioning || product.description}
              </p>
              {(product.productPath || product.storeUrl) && (
                <div className="btn-group reveal d3">
                  {product.productPath && (
                    <Link to={product.productPath} className="btn btn-primary" data-testid={`product-cta-${product.id}`}>
                      Explore {product.name}
                    </Link>
                  )}
                  {product.storeUrl && (
                    <a
                      href={product.storeUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-ghost"
                      data-testid={`store-cta-${product.id}`}
                    >
                      <i className="fab fa-google-play"></i> {product.storeLabel}
                    </a>
                  )}
                </div>
              )}
            </div>
          ))}
        </div>
      </section>
      <Footer />
    </PageWrap>
  );
}
